"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Help = /** @class */ (function () {
    function Help() {
    }
    /**
     * https://stackoverflow.com/questions/1418569/javascript-max-function-for-3-numbers
     * @param array
     */
    Help.maxOfArray = function (array) {
        return Math.max.apply(Math, array);
    };
    /**
     * Will merge the properties of two objects
     * Does not handle arrays - see ChartHelp.mergeChartData for merging of arrays by index using assign and map
     * Will happily work with arrays instead of objects - just treats each index like an ojbect key item
     * Will also happily replace an objects property that is an array
     * Only works one level deep - either objects or arrays
     * */
    Help.mergeObjects = function (obj1, obj2) {
        return Object.assign(obj1, obj2);
    };
    /**
     * Take an object to work on, a string dot notation path e.g. "user.address.postcode" and returns the value of the object at that "path"
     * If the third param "value" is passed then will set the relevant key to that value
     * //https://stackoverflow.com/questions/6393943/convert-javascript-string-in-dot-notation-into-an-object-reference
     * @param obj - Target object
     * @param stringPath - path on that object
     * @param value - (optional) value to set
     */
    Help.objReferenceFromString = function (obj, stringPath, value) {
        if (typeof stringPath == 'string')
            return Help.objReferenceFromString(obj, stringPath.split('.'), value);
        else if (stringPath.length == 1 && value !== undefined)
            return obj[stringPath[0]] = value;
        else if (stringPath.length == 0)
            return obj;
        else
            return Help.objReferenceFromString(obj[stringPath[0]], stringPath.slice(1), value);
    };
    Help.sqftTosqm = function (s) {
        var respVal = null;
        if (!Help.isNullOrUndef(s)) {
            respVal = (s / 10.764).toFixed(0);
        }
        return respVal;
    };
    Help.numberedLabel = function (l, n) {
        return l + " <i>" + n + "</i>";
    };
    Help.coloredNumberedLabel = function (l, n, c) {
        return "<span class=\"" + c + "\"></span>" + l + " <i>" + n + "</i>";
    };
    Help.labelledTag = function (l, s, t, c) {
        if (c === void 0) { c = ""; }
        return Help.isGoodString(s) ? "<span class=\"label " + c + "\">" + l + "</span>" + Help.htmlTag(s, t) : "";
    };
    Help.labelledList = function (l, s) {
        var str = Help.htmlList(s);
        return Help.isGoodString(str) ? "<span class=\"label\">" + l + "</span>" + str : "";
    };
    Help.htmlTag = function (s, t, as) {
        if (as === void 0) { as = ""; }
        return Help.isGoodString(s) ? "<" + t + " " + as + ">" + s + "</" + t + ">" : "";
    };
    Help.htmlList = function (s) {
        var respVal = "";
        if (!Help.isNullOrUndef(s) && s.length > 0) {
            respVal = "<ul>";
            s.forEach(function (v) { return respVal += "<li>" + v + "</li>"; });
            respVal += "</ul>";
        }
        return respVal;
    };
    Help.trimEnd = function (s) {
        return s.slice(0, -1);
    };
    Help.trimEndCharacters = function (s, targetString) {
        if (targetString === undefined)
            targetString = "\s";
        return s.replace(new RegExp("[" + targetString + "]+$"), "");
    };
    /**
    * Fairly lame don't expect magic
    */
    Help.singulariseWord = function (s) {
        var respVal = s;
        if (!s.endsWith("ss")) {
            Help.trimEndCharacters(s, "s");
        }
        return respVal;
    };
    /**
     * Fairly lame don't expect magic
     */
    Help.singulariseWords = function (s) {
        var respVal = s;
        var parts = s.split(" ");
        if (parts.length > 0) {
            respVal = "";
            parts.forEach(function (p) { return respVal += Help.singulariseWord(p) + " "; });
        }
        return respVal;
    };
    Help.removeFullStop = function (s) {
        return s.replace('.', '');
    };
    Help.splitStringOnWhitepace = function (s) {
        var respVal = [];
        if (Help.isGoodString(s)) {
            respVal = s.split(" ");
        }
        return respVal;
    };
    Help.splitStringOnLinebreaks = function (s) {
        var respVal = [];
        if (Help.isGoodString(s)) {
            respVal = s.split(/\r?\n/g);
        }
        return respVal;
    };
    //cref:https://gist.github.com/jonlabelle/5375315
    Help.splitOnCamelCase = function (str) {
        //str = str.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, '$1 $2');
        //str = str.toLowerCase(); //add space between camelCase text
        return str.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, '$1 $2');
    };
    Help.camelCaseFirstLetter = function (str) {
        return str.charAt(0).toLowerCase() + str.substring(1);
    };
    Help.pascalCaseFirstLetter = function (str) {
        return str.charAt(0).toUpperCase() + str.substring(1);
    };
    Help.formatEnumText = function (str) {
        return Help.pascalCaseFirstLetter(Help.splitOnCamelCase(str));
    };
    Help.getEnumNames = function (s) {
        var enumNames = []; //var enumNames = Array<string>();
        for (var keyVal in s) {
            if (isNaN(Number(keyVal))) {
                enumNames.push(keyVal);
            }
        }
        return enumNames;
    };
    Help.getEnumValues = function (s) {
        var enumValues = []; //var enumValues = Array<string>();
        for (var keyVal in s) {
            if (!isNaN(Number(keyVal))) {
                enumValues.push(keyVal);
            }
        }
        return enumValues;
    };
    Help.isGoodString = function (s) {
        return !Help.isNullOrEmpty(s) && Help.isString(s);
    };
    Help.isGoodNumber = function (s) {
        return !Help.isNullOrUndef(s) && Help.isNumber(s);
    };
    Help.isNumber = function (n) {
        return typeof n === "number";
    };
    Help.isString = function (n) {
        return typeof n === "string";
    };
    Help.StringtContains = function (s, t) {
        return (s.indexOf(t) >= 0);
    };
    Help.isNullOrUndef = function (val) {
        return val === undefined || val === null;
    };
    Help.isNullOrEmpty = function (val) {
        return Help.isNullOrUndef(val) || val === '' || val === 'null' || val === 'undefined';
    };
    Help.stringContains = function (term, source) {
        var respVal = false;
        if (Help.isString(term)) {
            respVal = (source.indexOf(term) !== -1);
        }
        return respVal;
    };
    Help.getProp = function (key, obj, defaultVal) {
        if (defaultVal === void 0) { defaultVal = null; }
        return Help.hasProp(key, obj) ? obj[key] : defaultVal;
    };
    Help.tryGetProp = function (key, obj, result) {
        var respVal = false;
        if (Help.hasProp(key, obj)) {
            result.value = Help.getProp(key, obj);
            respVal = true;
        }
        return respVal;
    };
    Help.hasProp = function (key, obj) {
        return (key in obj);
    };
    Help.getItem = function (ary, i, defaultVal) {
        if (defaultVal === void 0) { defaultVal = null; }
        return !Help.isNullOrUndef(ary) ? ary[i] : defaultVal;
    };
    Help.hasIndex = function (arr, i) {
        return (arr[i] != null);
    };
    Help.contains = function (arr, item) {
        if (Array.isArray(arr)) {
            return arr.indexOf(item) > -1;
        }
        return false;
    };
    Help.first = function (arr) {
        return arr[0];
    };
    Help.last = function (arr) {
        return arr[arr.length - 1];
    };
    Help.sumArray = function (arr) {
        return arr.reduce(function (a, b) {
            return a + b;
        }, 0);
    };
    Help.flatten = function (arr) {
        var _a;
        return (_a = []).concat.apply(_a, arr);
    };
    /**
    * creates an entirely new array that is a copy of the original array, except with the target item remove.
    */
    Help.newArrayWithoutItem = function (arr, item) {
        return arr.filter(function (e) { return e !== item; });
    };
    /**
    * mutates array with splice
    */
    Help.removeItemFromArray = function (arr, item) {
        var indexToDelete = arr.indexOf(item);
        if (indexToDelete >= 0) {
            arr.splice(indexToDelete, 1);
        }
    };
    //http://trafalgar.uv.co.uk/?q=visitors-section or http://onedorset.uv.co.uk/?q=visitors-section&approvalId=160e7cf9-d40d-41b2-874f-f3405c295e8b
    Help.scrollToIntraLink = function (hash) {
        //console.log("help scrollToIntraLink");
        //let queryString : string = Help.getQueryStringFromUrl(window.location.href);
        //window.location.hash = "#" + hash; //TODO:TD this works but leaves url ugly
        window.location.hash = "#" + hash; //TODO:TD this works but leaves url ugly i.e. adds #visitors-section
        //but we don't mind as it also ensures URL displayed always gives same result
        //will end up with e.g. http://onedorset.uv.co.uk/?q=visitors-section&approvalId=160e7cf9-d40d-41b2-874f-f3405c295e8b#visitors-section 
        //which works.
        //window.history.replaceState({}, document.title, `/${}#${hash}`); //this fixes the url in browser ! 
        //causes refresh ==> window.location.href = `${rawPath}/#${hash}`;// "" + hash; 
        //window.location.hash = "#" + hash;    
        //console.log(window.location.hash);   
    };
    Help.getQueryStringFromUrl = function (url) {
        return url.split("?")[1];
    };
    Help.stripQueryStringAndHashFromUrl = function (url) {
        return url.split("?")[0].split("#")[0];
    };
    Help.hasClass = function (element, cls) {
        return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
    };
    Help.objectsEqualByValue = function (obj1, obj2) {
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    };
    Help.deepCloneObject = function (obj) {
        return JSON.parse(JSON.stringify(obj));
    };
    Help.cloneObject = function (obj) {
        return Object.assign({}, obj);
    };
    Help.cloneExceptKey = function (obj, keyToRemove) {
        var clone = Object.assign({}, obj);
        delete clone[keyToRemove];
        return clone;
    };
    Help.cloneAndMod = function (obj, kvpsToOverwrite) {
        var overwritten = Object.assign({}, obj, kvpsToOverwrite);
        return overwritten;
    };
    Help.isValidDate = function (val) {
        var respVal = false;
        if (Object.prototype.toString.call(val) === "[object Date]") {
            if (!isNaN(val.getTime())) {
                respVal = true;
            }
        }
        return respVal;
    };
    Help.numberTryParse = function (intString, result) {
        result.value = parseInt(intString, 10);
        return !isNaN(result.value);
    };
    Help.randomScalingFactor = function () {
        return Math.round(Math.random() * 100);
    };
    ;
    return Help;
}());
exports.default = Help;
//# sourceMappingURL=Help.js.map